import { FC } from 'react';
import { BottomTabProps } from './model';

export const BottomTab: FC<BottomTabProps> = ({ children }) => <>{children}</>;
